<template>
  <div class="customized-img" v-if="item">
    <div
      v-if="
        sliderImages.normal_size.length &&
          sliderImages.normal_size[0] &&
          sliderImages.normal_size[0].url.length
      "
    >
      <swiper
        class="swiper gallery-top"
        :options="swiperOptionTop"
        ref="swiperTop"
      >
        <swiper-slide
          :key="k"
          v-for="(img, k) of sliderImages.normal_size"
          :class="'slide-' + k"
        >
          <inner-image-zoom
            :src="img.url"
            :zoomSrc="sliderImages.large_size[k].url"
            :alt="item.name"
            fullscreenOnMobile
          />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <swiper
        class="swiper gallery-thumbs"
        :options="swiperOptionThumbs"
        ref="swiperThumbs"
      >
        <swiper-slide
          :key="k"
          v-for="(img, k) of sliderImages.thumbs"
          :class="'slide-' + k"
        >
          <img :src="img.url" />
        </swiper-slide>
      </swiper>
    </div>
    <div
      v-else
      :style="{
        'background-color': item.item_color ? item.item_color : '#f02',
      }"
      class="bg-size"
    ></div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import InnerImageZoom from 'vue-inner-image-zoom'
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css'
import 'swiper/css/swiper.css'
export default {
  name: 'Top',
  computed: {
    ...mapGetters(['_T_DB', '_T']),
    ...mapState({
      item: state => state.cart_store.selectedItem,
    }),
  },
  data() {
    return {
      currentImagePath: '',
      isLoading: true,
      sliderImages: {
        thumbs: [],
        normal_size: [],
        large_size: [],
      },
      swiperOptionTop: {
        updateOnWindowResize: true,
        allowTouchMove: true,
        slidesPerView: 1,
        allowSlidePrev: true,
        allowSlideNext: true,
        spaceBetween: 10,
        preloadImages: true,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionThumbs: {
        loop: false,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
    }
  },
  methods: {
    close() {
      this.$store.commit('SET_ITEM_DETAIL_POPUP')
      document.body.classList.remove('body-overlay')
    },
    getImage() {
      if (this.item && this.item.image) {
        let url = this.item.image.split('menu/')
        this.currentImagePath = url[1]
          ? url[0] + 'menu/large/' + url[1]
          : this.item.image
        this.currentImagePath = this.currentImagePath.replace('(', '%28')
        this.currentImagePath = this.currentImagePath.replace(')', '%29')
        let that = this
        this.sliderImages = {
          thumbs: [],
          normal_size: [],
          large_size: [],
        }
        var multiImg = this.item.images
        if (multiImg.length == 0) {
          multiImg = [
            {
              _id: { $oid: this.item._id },
              image: this.item.image,
            },
          ]
        }
        multiImg.map(i => {
          let imgUrl = i.image.split('menu/')
          let imgPathThumb = i.image
          let imgPathNormal = imgUrl[1]
            ? imgUrl[0] + 'menu/large/' + imgUrl[1]
            : i.image
          let imgPathOriginal = imgUrl[1]
            ? imgUrl[0] + 'menu/original/' + imgUrl[1]
            : i.image
          that.sliderImages.thumbs.push({
            id: i._id.$oid,
            url: imgPathThumb,
          })
          that.sliderImages.normal_size.push({
            id: i._id.$oid,
            url: imgPathNormal,
          })
          that.sliderImages.large_size.push({
            id: i._id.$oid,
            url: imgPathOriginal,
          })
        })
      }
    },
  },
  beforeDestroy() {
    this.currentImagePath = ''
    this.sliderImages = {
      thumbs: [],
      normal_size: [],
      large_size: [],
    }
  },
  watch: {
    item(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.getImage()
          const swiperTop = this.$refs.swiperTop.$swiper
          const swiperThumbs = this.$refs.swiperThumbs.$swiper
          swiperTop.controller.control = swiperThumbs
          swiperThumbs.controller.control = swiperTop
        })
      }
    },
  },
  components: {
    'inner-image-zoom': InnerImageZoom,
  },
}
</script>

<style lang="scss" scoped>
.swiper {
  .swiper-slide {
    background-size: cover;
    background-position: center;
  }

  &.gallery-top {
    height: 80%;
    width: 100%;
  }
  &.gallery-thumbs {
    height: 10%;
    box-sizing: border-box;
    padding: 5px 0;
  }
  &.gallery-thumbs .swiper-slide {
    width: 10%;
    height: 100%;
    opacity: 0.4;
  }
  &.gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }
  .swiper-button-prev {
    color: $color-primary;
  }
  .swiper-button-next {
    color: $color-primary;
  }
}

.swiper-container {
  z-index: 0 !important;
}
.customized-img {
  position: relative;
  .bg-size {
    background-size: contain !important;
    &:before {
      padding-top: 51%;
    }
  }
  img {
    width: 100%;
    height: auto;
  }
  .total-box {
    background: rgba(var(--color-font-color-source), 0.5);
    padding: $px10 $px12;
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: right;
    h6 {
      font-weight: normal;
      font-size: $px14;
      line-height: $px22;
      letter-spacing: 0.5px;
      color: $white;
      text-transform: capitalize;
      margin-bottom: $px5;
    }
    h5 {
      font-weight: normal;
      font-size: $px18;
      line-height: $px22;
      color: $color-primary;
      text-transform: uppercase;
      margin-bottom: 0;
    }
    &.light-version {
      background: rgba(var(--color-white-source), 0.5);
      h6 {
        color: $black;
      }
    }
  }
}
</style>
